'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridRemoveCalendarButtonController = function GridRemoveCalendarButtonController($scope, seasonalityConstants, $q, $timeout, restangular) {
  $scope.isRemoveCalendarShown = false;
  $scope.selectedRows = [];
  var CAL_STATUS = seasonalityConstants.CALENDAR_STATUSES;
  var INIT_STATUS = seasonalityConstants.CALENDAR_INIT_STATUSES;
  var validStatuses = [CAL_STATUS.FINISHED, CAL_STATUS.COMPLETED, CAL_STATUS.ERROR_PROCESSING];
  var initializationPendingStatus = [INIT_STATUS.NEW, INIT_STATUS.STARTED];
  function isCalendarStatusAllowRemoval(calendar) {
    return !_.includes(initializationPendingStatus, calendar.profileStatus) && _.includes(validStatuses, calendar.calendarStatus) && calendar.calendarEntryStatus !== CAL_STATUS.PUBLISHED;
  }
  $scope.getCalendarMode = function () {
    return $scope.screenState.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.SHOW_UP ? 'showupcalendars' : 'demandcalendars';
  };
  $scope.getCalendarsForRemoval = function () {
    return _.filter($scope.selectedRows, isCalendarStatusAllowRemoval);
  };
  $scope.isButtonShown = function () {
    return !_.isEmpty($scope.selectedRows) && !_.isEmpty($scope.calendarsForRemoval) && $scope.calendarsForRemoval.length === $scope.selectedRows.length;
  };
  $scope.onRowSelection = function (selectedRows) {
    $scope.selectedRows = selectedRows;
    $scope.calendarsForRemoval = $scope.getCalendarsForRemoval();
    $scope.isRemoveCalendarShown = $scope.isButtonShown();
  };
  $scope.getDeleteURL = function (calendar) {
    var splittedMarket = calendar.market.split('-');
    if (isPooledSeasonalityCalendar()) {
      return restangular.one('pooled/seasonality/calendars').one(calendar.calendarName).one(splittedMarket[0]).one(splittedMarket[1]);
    }
    var calendarMode = $scope.getCalendarMode();
    return restangular.one('partitioned/seasonality').one(calendarMode).one(calendar.calendarName).one(splittedMarket[0]).one(splittedMarket[1]);
  };
  function isPooledSeasonalityCalendar() {
    return $scope.screenState.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.DEMAND && $scope.isPooledSeasonalityEnabled;
  }
  $scope.serverRemoveSuccess = function (calendar) {
    toastr.success('Successfully deleted calendar \n' + calendar.calendarName);
  };
  $scope.serverRemoveFailure = function (calendar) {
    toastr.error('Failed to remove calendar \n' + calendar.calendarName);
  };
  $scope.removeFromServer = function (calendar) {
    return $scope.getDeleteURL(calendar).remove().then(function () {
      $scope.serverRemoveSuccess(calendar);
    }, function () {
      $scope.serverRemoveFailure(calendar);
    });
  };
  $scope.removeCalendars = function () {
    var deletePromises = _.reduce($scope.calendarsForRemoval, function (result, calendar) {
      result.push($scope.removeFromServer(calendar));
      return result;
    }, []);
    $q.all(deletePromises).then(function () {
      $scope.gridPanelScope.refreshGrid();
    });
  };
};
GridRemoveCalendarButtonController.$inject = ['$scope', 'SeasonalityConstants', '$q', '$timeout', 'Restangular'];
module.exports = GridRemoveCalendarButtonController;